import React, { useState, useEffect } from "react";
import {
  TableCell,
  TableRow,
  Typography,
  TextField,
  Select,
  MenuItem,
  Button,
  IconButton,
  InputAdornment,
  Link,
  Tooltip,
} from "@material-ui/core";
import WarningIcon from "@mui/icons-material/Warning";
import SaveIcon from "@mui/icons-material/Save";
import ErrorIcon from '@mui/icons-material/Error';
import styles from "../styles";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContentWrapper from "../../../components/SnackbarContentWrapper";
import { connect } from "react-redux";
import { getPersonInfoWithName } from "../../../redux/demographics/demographicsActions";
import { getStudentApiAccommodations } from "../../../services/student/v1/student";
import { updateStudentAccommodation } from "../../../services/faculty/v1/faculty";

function CourseTableRow(props) {
  const useStyles = styles;
  const classes = useStyles();

  const ADA = "ADA";
  const TitleIX = "Title IX";
  const ADATitleIX = "ADA/Title IX";

  const [originalNote, setOriginalNote] = useState(
    props.student.notes ?? ""
  );
  const [noteValue, setNoteValue] = useState(
    props.student.notes ?? ""
  );
  const [noteHasChanged, setNoteHasChanged] = useState(false);
  const [disabilityType, setDisabilityType] = useState("");
  const [accommodationTypesAcknowledged, setAccommodationTypesAcknowledged] =
    useState([]);
  const [newAccommodationTypes, setNewAccommodationTypes] = useState([]);

  const [focused, setFocused] = useState(false);

  const [openSuccess, setOpenSuccess] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("");

  const [gradeValue, setGradeValue] = useState(
    props.student?.isFinalGradePosted
  );
  const [accommodationObject, setAccommodationObject] = useState({});
  const [hasAcknowledgedAccommodation, setHasAcknowledgedAccommodation] =
    useState(false);
  const [studentApiCalled, setStudentApiCalled] = useState(false);
  const [attemptedAccomodationUpdate, setAttemptedAccommodationUpdate] = useState({
    updateType: "",
    updateValue: ""
  })

  const [mainRowInfoObject, setMainRowInfoObject] = useState({
    studentAccommodationInfoId: props.student?.studentAccommodationInfoId,
    facultyIrn: props.student?.facultyIrn,
    facultyPersonId: props.student?.facultyPersonId,
    studentIrn: props.student?.studentIrn,
    studentPersonId: props.student?.studentPersonId,
    studentName: props.student?.fullName,
    notes: props.student?.notes,
    finalGradePosted: props.student?.isFinalGradePosted,
    courseId: props.courseId,
    courseOfferingId: props.courseOfferingId,
    courseStartDate: props.courseStartDate,
    courseEndDate: props.courseEndDate,
    receivingFromFwsDatabase: props.student?.receivingFromFwsDatabase,
    dateCreated: props.student?.dateCreated,
    createdBy: props.student?.createdBy,
    dateModified: props.student?.dateModified,
    modifiedBy: props.student?.modifiedBy,
    displayAccommodationTypes: [], //This is for display accommodation types in ActionNeeded.jsx
    disabilityType: "",
    notificationType: "",
    dbResponse: null,
  });
  
  useEffect(() => {
    setAccommodationObject({
      id: props.student.studentAccommodationInfoId,
      facultyIRN: props.facultyDemographics.issuerId,
      facultyPersonId: props.facultyDemographics.personId,
      studentIRN: props.student.studentIRN,
      studentPersonId: props.student.studentPersonId,
      courseOfferingId: props.student.courseOfferingId,
      notes: props.student.notes,
      isFinalGradePosted: props.student.isFinalGradePosted,
      dateCreated: props.student.dateCreated,
      dateModified: props.student.dateModified,
      modifiedBy: props.student.modifiedBy,
    });
    
    setOriginalNote(props.student.notes ?? "");
    setNoteValue(props.student.notes ?? "");
    setNoteHasChanged(false);
    setGradeValue(props.student.isFinalGradePosted);
  }, [props.student]); // eslint-disable-line react-hooks/exhaustive-deps

  // =========================================================================================================================
  // Call for SRM endpoint if student information does not come from fws database.
  const [studentSrmApiInfo, setStudentSrmApiInfo] = useState({});

  const handleSrmApiEndpoint = async (personId) => {
    await getStudentApiAccommodations(personId)
      .then((response) => {
        setStudentSrmApiInfo(response);
      })
      .catch((error) => {
        setSnackbarType("error");
        setSnackbarMessage(
          "Failed to call get student accommdations from srm."
        );
        setOpenSuccess(true);
        console.log(error.request);
      });
  };

  useEffect(() => {
    if (
      !props.student.receivingFromFwsDatabase &&
      props.student.studentPersonId &&
      !studentApiCalled
    ) {
      handleSrmApiEndpoint(props.student.studentPersonId);
      setStudentApiCalled(true);
    }
  }, [props.student.receivingFromFwsDatabase, props.student.studentPersonId, studentApiCalled]); // eslint-disable-line react-hooks/exhaustive-deps
  // =========================================================================================================================

  // =========================================================================================================================
  // Set new and already acknowledged acknowledgements to display to the the screen for student.
  const [hasNewAccommodation, setHasNewAccommodation] = useState(false); //sets row red/white
  const [notificationType, setNotificationType] = useState(""); // ADA, Title IX, or Dual

  useEffect(() => {
    if (props.student.receivingFromFwsDatabase && props.student.facultyAcknowledgements?.length > 0) {
      handleFwsData();
    } else if (!props.student.receivingFromFwsDatabase && studentSrmApiInfo.status === 200) {
      handleSrmData();
    }
  }, [studentSrmApiInfo, props.update, props.student.receivingFromFwsDatabase, props.student.facultyAcknowledgements]);

  const handleUpdatedRow = (facultyAcknowledgements) => {
    let tempAccommodationTypesAcknowledged = [];

    if (facultyAcknowledgements?.length >= 1) {
      facultyAcknowledgements.forEach((accommodation) => {
        const isNullDates =
          accommodation.accommodationStartDate === null &&
          accommodation.accommodationEndDate === null;

        if (accommodation.dateAcknowledged) {
          setHasAcknowledgedAccommodation(true);
        }

        const isWithinDateRange = () => { 
          if (!isNullDates) {
            const startDate = new Date(accommodation.accommodationStartDate);
            const endDate = new Date(accommodation.accommodationEndDate);
            const courseStartDate = mainRowInfoObject.courseStartDate
              ? new Date(mainRowInfoObject.courseStartDate)
              : null;
            const courseEndDate = mainRowInfoObject.courseEndDate
              ? new Date(mainRowInfoObject.courseEndDate)
              : null;
            return (
              (endDate &&
                endDate >= courseStartDate &&
                endDate <= courseEndDate) ||
              (endDate &&
                endDate > courseEndDate) ||
              (startDate &&
                startDate >= courseStartDate &&
                startDate <= courseEndDate) ||
              (startDate &&
                endDate &&
                startDate <= courseStartDate &&
                endDate >= courseEndDate)
            );
          }
          return true;
        };

        const accommodationCourseMatch =
          accommodation.courseId === null
            ? true
            : accommodation.courseId === props.courseId
            ? true
            : false;

        const isApproved =
          accommodation.status?.toLowerCase() === "approved" ||
          accommodation.status === null;

        if (accommodationCourseMatch && isWithinDateRange() && isApproved) {
          tempAccommodationTypesAcknowledged.push(
            accommodation.accommodationType
          );
        }
      });
    }
    return sortAndOrderAccommodations(tempAccommodationTypesAcknowledged);
  };

  // Helper function to process accommodations
  const processAccommodations = (facultyAcknowledgements) => {
    let tempAccommodationTypesAcknowledged = [];
    let tempNewAccommodationTypes = [];

    if (facultyAcknowledgements?.length >= 1) {
      facultyAcknowledgements.forEach((accommodation) => {
        const isNullDates =
          accommodation.accommodationStartDate === null &&
          accommodation.accommodationEndDate === null;

        if (accommodation.dateAcknowledged) {
          setHasAcknowledgedAccommodation(true);
        }

        const isWithinDateRange = () => {
          if (!isNullDates) {
            const startDate = new Date(accommodation.accommodationStartDate);
            const endDate = new Date(accommodation.accommodationEndDate);
            const courseStartDate = mainRowInfoObject.courseStartDate
              ? new Date(mainRowInfoObject.courseStartDate)
              : null;
            const courseEndDate = mainRowInfoObject.courseEndDate
              ? new Date(mainRowInfoObject.courseEndDate)
              : null;
            return (
              (endDate &&
                endDate >= courseStartDate &&
                endDate <= courseEndDate) ||
              (endDate &&
                endDate > courseEndDate) ||
              (startDate &&
                startDate >= courseStartDate &&
                startDate <= courseEndDate) ||
              (startDate &&
                endDate &&
                startDate <= courseStartDate &&
                endDate >= courseEndDate)
            );
          }
          return true;
        };

        const accommodationCourseMatch =
          accommodation.courseId === null
            ? true
            : accommodation.courseId === props.courseId
            ? true
            : false;

        const isApproved =
          accommodation.status?.toLowerCase() === "approved" ||
          accommodation.status === null;

        if (accommodationCourseMatch && isWithinDateRange() && isApproved) {
          if (accommodation.dateAcknowledged === null) {
            tempNewAccommodationTypes.push(accommodation.accommodationType);
            setHasNewAccommodation(true);
          } else {
            tempAccommodationTypesAcknowledged.push(
              accommodation.accommodationType
            );
          }
        }
      });
    }

    return { 
      tempAccommodationTypesAcknowledged: sortAndOrderAccommodations(tempAccommodationTypesAcknowledged), 
      tempNewAccommodationTypes: sortAndOrderAccommodations(tempNewAccommodationTypes) 
    }; 
  };

  // Disability type and notification logic functions
  const isDual = (disabilityType) => {
    if (!disabilityType) return false;
    const lower = disabilityType.toLowerCase();
    return (lower.includes('ada') && lower.includes('title ix')) || 
           lower.includes('ada/title ix');
  };

  const checkForUnacknowledgedAccommodations = (facultyAcknowledgements) => {
    if (!facultyAcknowledgements?.length) return false;
    
    // Check if any accommodation is unacknowledged (new acknowledgments needed)
    return facultyAcknowledgements.some(acc => !acc.dateAcknowledged);
  };

  const determineNotificationType = (currentDisabilityType, facultyAcknowledgements) => {
    const needsNewAcknowledgment = checkForUnacknowledgedAccommodations(facultyAcknowledgements);
    
    // Check if there's any ADA/Title IX acknowledgement in history
    const hasADATitle9Acknowledged = facultyAcknowledgements?.some(acc => 
      acc.dateAcknowledged && acc.acknowledgedDisabilityType && isDual(acc.acknowledgedDisabilityType)
    );

    // If there's ever been an ADA/Title IX acknowledgement, always show ADA/Title IX notification
    if (hasADATitle9Acknowledged) {
      return ADATitleIX;
    }

    if (needsNewAcknowledgment || !facultyAcknowledgements?.length) {
      // Use current disability type for new accommodations
        return currentDisabilityType;
    } else {
      // If no new accommodations, use acknowledged disability type
      const acknowledgedType = facultyAcknowledgements[0]?.acknowledgedDisabilityType;
      if (acknowledgedType) {
        return acknowledgedType;
      }
    }
    
    return currentDisabilityType; // Fallback
  };

  // Handle FWS Database data
  const handleFwsData = () => {
    if (props.student.facultyAcknowledgements) {
      if (
        props.update.studentIrn === String(props.student.studentIrn) &&
        props.update.courseOfferingId === String(props.courseOfferingId)
      ) {
        const tempAccommodationTypesAcknowledged = handleUpdatedRow(
          props.student.facultyAcknowledgements
        );

        const currentNotificationType = determineNotificationType(props.student.facultyAcknowledgements[0].disabilityType, props.student.facultyAcknowledgements);       
        setDisabilityType(props.student.facultyAcknowledgements[0].disabilityType);
        setNotificationType(currentNotificationType);
        setMainRowInfoObject({
          ...mainRowInfoObject,
          studentAccommodationInfoId: props.student?.studentAccommodationInfoId,
          studentName: props.student?.fullName,
          studentPersonId: props.student?.studentPersonId,
          studentIrn: props.student?.studentIrn,
          receivingFromFwsDatabase: props.student?.receivingFromFwsDatabase,
          displayAccommodationTypes: [...tempAccommodationTypesAcknowledged],
          disabilityType: props.student.facultyAcknowledgements[0].disabilityType,
          notificationType: currentNotificationType,
          dbResponse: props.student?.facultyAcknowledgements,
        });
        setAccommodationTypesAcknowledged(tempAccommodationTypesAcknowledged);
        setNewAccommodationTypes([]);
        setHasNewAccommodation(false);
      } else {
        const {
          tempAccommodationTypesAcknowledged,
          tempNewAccommodationTypes,
        } = processAccommodations(props.student.facultyAcknowledgements);

        const currentNotificationType = determineNotificationType(props.student.facultyAcknowledgements[0].disabilityType, props.student.facultyAcknowledgements);  
        setDisabilityType(props.student.facultyAcknowledgements[0].disabilityType);
        setNotificationType(currentNotificationType);
        setMainRowInfoObject({
          ...mainRowInfoObject,
          studentAccommodationInfoId: props.student?.studentAccommodationInfoId,
          studentName: props.student?.fullName,
          studentPersonId: props.student?.studentPersonId,
          studentIrn: props.student?.studentIrn,
          receivingFromFwsDatabase: props.student?.receivingFromFwsDatabase,
          displayAccommodationTypes: [
            ...tempAccommodationTypesAcknowledged,
            ...tempNewAccommodationTypes,
          ],
          disabilityType: props.student.facultyAcknowledgements[0].disabilityType,
          notificationType: currentNotificationType,
          dbResponse: props.student?.facultyAcknowledgements,
        });
        setNewAccommodationTypes(sortAndOrderAccommodations(tempNewAccommodationTypes));
        setAccommodationTypesAcknowledged(tempAccommodationTypesAcknowledged);

        if (props.student.courseOfferingId === 0) {
          setHasNewAccommodation(true);
        }
      }
    }
  };

  // Handle SRM data
  const handleSrmData = () => {
    if (studentSrmApiInfo.status === 200) {

      // Conditions set for permanent accommodations coming from SRM
      const isMainActive = studentSrmApiInfo.data.isActive;
      const accommodationEndDate =  
        studentSrmApiInfo.data.accomEndDate !== null
        ? new Date(studentSrmApiInfo.data.accomEndDate)
        : null;
      const courseStartDate = mainRowInfoObject.courseStartDate
        ? new Date(mainRowInfoObject.courseStartDate)
        : null;
      const courseEndDate = mainRowInfoObject.courseEndDate
        ? new Date(mainRowInfoObject.courseEndDate)
        : null;
      const permConditions = [
        // isActive is true and accommodation end date is coming back null or accommodation end date is after course end date
        isMainActive && (!accommodationEndDate || accommodationEndDate > courseEndDate),
        // isActive is true and accommodation end date is between course start and end dates
        isMainActive && accommodationEndDate >= courseStartDate && accommodationEndDate <= courseEndDate,
        // isActive is false and accommodations end date is between course start and end dates or after course end date
        !isMainActive && ((accommodationEndDate >= courseStartDate && accommodationEndDate <= courseEndDate) || accommodationEndDate > courseEndDate)
      ];

      let tempNewAccommodationTypes = [];
      let srmAccommodations =
        studentSrmApiInfo.data.accommodationType !== null &&
        permConditions.some((condition) => condition)
          ? studentSrmApiInfo.data.accommodationType.split(";")
          : [];
      srmAccommodations =
        studentSrmApiInfo.data.specialArrangements !== null &&
        studentSrmApiInfo.data.specialArrangements !== "" && 
        permConditions.some((condition) => condition)
          ? [...srmAccommodations, studentSrmApiInfo.data.specialArrangements]
          : [...srmAccommodations];
      const srmTempAccommodations = studentSrmApiInfo.data.tempAccoms || [];

      tempNewAccommodationTypes = [...srmAccommodations];

      srmTempAccommodations.forEach((accommodation) => {
        if (accommodation.accommodationType) {
          const courseStartDate = mainRowInfoObject.courseStartDate
            ? new Date(mainRowInfoObject.courseStartDate)
            : null;
          const courseEndDate = mainRowInfoObject.courseEndDate
            ? new Date(mainRowInfoObject.courseEndDate)
            : null;
          const startDate = accommodation.startDate
            ? new Date(accommodation.startDate)
            : null;
          const endDate = accommodation.endDate
            ? new Date(accommodation.endDate)
            : null;
          const isApproved =
            accommodation.status?.toLowerCase() === "approved" ||
            accommodation.status === null;
          // if courseId is null - it is not specific to a course. otherwise, courseId has to match
          const accommodationCourseMatch =
            accommodation.courseId === null
              ? true
              : accommodation.courseId === props.courseId
              ? true
              : false;

          if (isApproved && accommodationCourseMatch) {
            const tempConditions = [
              // End date exists and is within range of course start date and course end date
              endDate && endDate >= courseStartDate && endDate <= courseEndDate,
              // Start date exists and is within range of course start date and course end date
              startDate &&
                startDate >= courseStartDate &&
                startDate <= courseEndDate,
              // Both dates exist and start date is before course start date and end date is after course end date
              startDate &&
                endDate &&
                startDate <= courseStartDate &&
                endDate >= courseEndDate,
              // Both dates are null
              !startDate && !endDate,
              // Only startDate exists and current date is after startDate
              startDate && !endDate && courseStartDate >= startDate,
              // Only endDate exists and current date is before endDate
              !startDate && endDate && courseEndDate <= endDate,
            ];

            if (tempConditions.some((condition) => condition)) {
              let tempSrmAccommodations =
                accommodation.accommodationType !== null
                  ? accommodation.accommodationType.split(";")
                  : [];
              tempNewAccommodationTypes = [
                ...tempNewAccommodationTypes,
                ...tempSrmAccommodations,
              ];
              if (
                accommodation.specialArrangements !== null &&
                accommodation.specialArrangements !== ""
              ) {
                tempNewAccommodationTypes = [
                  ...tempNewAccommodationTypes,
                  accommodation.specialArrangements,
                ];
              }
            }
          }
        }
      });

      // When no accommodations present in FWS DB, use disability type from payload
      setHasNewAccommodation(true);
      setDisabilityType(studentSrmApiInfo.data.disabilityType);
      setNotificationType(studentSrmApiInfo.data.disabilityType);  
      setMainRowInfoObject({
        ...mainRowInfoObject,
        studentAccommodationInfoId: props.student?.studentAccommodationInfoId,
        studentName: props.student?.fullName,
        studentPersonId: props.student?.studentPersonId,
        studentIrn: props.student?.studentIrn,
        receivingFromFwsDatabase: props.student?.receivingFromFwsDatabase,
        displayAccommodationTypes: [...tempNewAccommodationTypes],
        disabilityType: studentSrmApiInfo.data.disabilityType,
        notificationType: studentSrmApiInfo.data.disabilityType,
        dbResponse: studentSrmApiInfo.data,
      });
      setNewAccommodationTypes(sortAndOrderAccommodations(tempNewAccommodationTypes));
      setAccommodationTypesAcknowledged([]);
    }
  };

  const handleOpenModal = () => {
    props.setActionNeededObject({
      ...mainRowInfoObject,
      studentName: props.student?.fullName !== "null null" ? props.student?.fullName : ""
    });
    if (hasNewAccommodation) {
      props.setAlreadyAcknowledged(false);
    } else {
      props.setAlreadyAcknowledged(true);
    }
    props.setModalType("action");
    props.setOpenModal(true);
  };

  const handleFocus = () => {
    setFocused(true);
  };

  const handleNotesChange = (event) => {
    if (originalNote !== event.target.value) {
      setNoteHasChanged(true);
    } else {
      setNoteHasChanged(false);
    }

    setNoteValue(event.target.value);
  };

  const handleSaveNotes = () => {
    setAttemptedAccommodationUpdate({
      updateType: "notes",
      updateValue: noteValue
    })
    // Use a callback to ensure the state is fully updated before calling the API
    const updatedObject = {
      ...accommodationObject,
      dateCreated: props.student.dateCreated,
      dateModified: new Date().toISOString(),
      modifiedBy: `${props.facultyDemographics?.username}`,
      notes: noteValue,
    };

    handleUpdateStudentAccommodation(updatedObject, "notes");
  };

  const handleGradeChange = (event) => {
    const value = event.target.value === "Yes" ? true : false;

    setAttemptedAccommodationUpdate({
      updateType: "grade",
      updateValue: value
    })

    // Use a callback to ensure the state is fully updated before calling the API
    const updatedObject = {
      ...accommodationObject,
      dateCreated: props.student.dateCreated,
      dateModified: new Date().toISOString(),
      modifiedBy: `${props.facultyDemographics?.username}`,
      isFinalGradePosted: value,
    };

    handleUpdateStudentAccommodation(updatedObject, "grade");
  };

  const handleUpdateStudentAccommodation = async (accommodation, type) => {
    await updateStudentAccommodation(accommodation)
      .then((res) => {
        switch (type) {
          case "grade":
            setSnackbarMessage("Updated final grade");
            setGradeValue(accommodation.isFinalGradePosted);
            setAccommodationObject(accommodation);
            setMainRowInfoObject((prevState) => ({
              ...prevState,
              finalGradePosted: accommodation.isFinalGradePosted,
            }));
            break;
          case "notes":
            setSnackbarMessage("Updated notes");
            setNoteHasChanged(false);
            setOriginalNote(accommodation.notes);
            setNoteValue(accommodation.notes);
            setAccommodationObject(accommodation);
            props.setUpdate({
              studentIrn: `${accommodation.studentIrn}`,
              courseOfferingId: `${accommodation.courseOfferingId}`,
            });
            setMainRowInfoObject((prevState) => ({
              ...prevState,
              notes: accommodation.notes,
            }));
            break;
          default:
            break;
        }
        setSnackbarType("success");
        setOpenSuccess(true);
      })
      .catch((error) => {
        console.log(error);
        setSnackbarType("error");
        setSnackbarMessage("Failed to update student accommodation.");
        setOpenSuccess(true);
      });
  };

  // =========================================================================================================================
  // Below code is to handle snackbars for successful or errored submissions
  const renderSnackbar = () => (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={openSuccess}
        autoHideDuration={snackbarType === "success" ? 10000 : 13000}
        onClose={handleCloseSnackBar}
      >
        <SnackbarContentWrapper
          onClose={handleClose}
          handleRetryClick={handleRetryApiCall}
          variant={snackbarType}
          message={snackbarMessage}
        />
      </Snackbar>
    </>
  );

  const handleCloseSnackBar = (event, reason) => {
    setOpenSuccess(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccess(false);
  };

  const handleRetryApiCall = () => {
    switch (snackbarMessage) {
      case "Failed to update student accommodation.":
        if (attemptedAccomodationUpdate.updateType === "notes") {
          const updatedObject = {
            ...accommodationObject,
            dateCreated: props.student.dateCreated,
            dateModified: new Date().toISOString(),
            modifiedBy: `${props.facultyDemographics?.username}`,
            notes: attemptedAccomodationUpdate.updateValue,
          };
      
          handleUpdateStudentAccommodation(updatedObject, attemptedAccomodationUpdate.updateType);
        };
        if (attemptedAccomodationUpdate.updateType === "grade") {
          const updatedObject = {
            ...accommodationObject,
            dateCreated: props.student.dateCreated,
            dateModified: new Date().toISOString(),
            modifiedBy: `${props.facultyDemographics?.username}`,
            isFinalGradePosted: attemptedAccomodationUpdate.updateValue,
          };
      
          handleUpdateStudentAccommodation(updatedObject, attemptedAccomodationUpdate.updateType);
        };
        break;
      case "Failed to call get student accommdations from srm.":
        handleSrmApiEndpoint(props.student.studentPersonId);
        break;
      default:
        break;
    }
  };
  // =========================================================================================================================

  const accommodations = [
    { text: "Ability to record lecture", id: "Ability-To-Record-Lecture" },
    { text: "Accessibility Modifications", id: "Accessibility-Modifications" },
    {
      text: "Alternatively Formatted Textbooks and/or class materials",
      id: "Alternatively-Formatted-Textbooks-And-Or-Class-Materials",
    },
    { text: "Alternative Assignment", id: "Alternative-Assignments" },
    { text: "Appointment to Clarify", id: "Appointment-To-Clarify" },
    { text: "Captions", id: "Captions" },
    {
      text: "Communication Access Real-Time Transcription (CART)",
      id: "Communication-Access-Real-Time-Transcription-(Live-Meeting-Captions)",
    },
    { text: "Direct Assessment", id: "Direct-Assessment" },
    { text: "Discussion Question and Participation Modification Accommodation", id: "DQ" },
    { text: "Email Summary of Meetings", id: "Email-Summary-Of-Meetings" },
    { text: "Ergonomic Equipment", id: "Ergonomic-Equipment" },
    {
      text: "Extended Time Accommodation for Individual Assignments",
      id: "Extended-Time-For-Individual-Assignments",
    },
    {
      text: "Extended Time for Competency Assessment",
      id: "Extended-Time-For-Competency-Assessments",
    },
    {
      text: "Extended Time for Exams & Quizzes",
      id: "Extended-Time-For-Exams-And-Quizzes",
    },
    { text: "Frequent breaks", id: "Frequent-Breaks" },
    {
      text: "Individual presentations or recorded presentations",
      id: "Individual-Or-Recorded-Presentations",
    },
    { text: "Laptop and tablet use in classroom", id: "Laptop-Used-In-Class" },
    { text: "Modified Course Services", id: "Modified-Course-Services" },
    { text: "Note-taking", id: "Note-Taking" },
    { text: "PDF", id: "PDF" },
    { text: "Pre-Course Check In", id: "Pre-Course-Check" },
    { text: "Preferential seating", id: "Preferential-Seating" },
    { text: "Printed text", id: "Printed-Text" },
    { text: "Provision of digital recording device" },
    { text: "Quiet Separate Room", id: "Quiet-Separate-Room" },
    { text: "Remote Attendance", id: "Remote-Attendance" },
    { text: "Scribe/Aide", id: "Scribe-Aide" },
    { text: "Service Animal", id: "Service-Animal" },
    { text: "Sign Language Interpreting", id: "Sign-Language-Interpreting" },
    { text: "Transcripts", id: "Transcripts" },
    { text: "Writing Lab", id: "Writing-Lab" },
  ];

  const oldToNewAccommodationMapping = {
    "Additional time individual assignments (previous IX policy)": "Extended Time Accommodation for Individual Assignments",
    "Ability to record lecture": "Ability to record lecture",
    "Alternatively formatted textbooks and/or class materials": "Alternatively Formatted Textbooks and/or class materials",
    "Communication Access Real-time Transcription (CART)": "Communication Access Real-Time Transcription (CART)",
    "Email summary of in person or phone meetings": "Email Summary of Meetings",
    "Note-taking": "Note-taking",
    "Phone appt to clarify course info or assignment expectations": "Appointment to Clarify",
    "Printed Text": "Printed text",
    "ASL Interpreter": "Sign Language Interpreting",
    "Frequent breaks": "Frequent breaks",
    "Preferential seating": "Preferential seating",
    "Quiet testing room": "Quiet Separate Room",
    "Individual presentations or recorded presentations": "Individual presentations or recorded presentations",
    "Ergonomic seating": "Ergonomic Equipment",
    "Laptop and tablet use in classroom": "Laptop and tablet use in classroom",
    "Writing Lab": "Writing Lab",
    "Extended Time for Competency Assessment": "Extended Time for Competency Assessment",
    "Extended Time Accommodation for Individual Assignments": "Extended Time Accommodation for Individual Assignments",
    "Extended Time for Exams & Quizzes": "Extended Time for Exams & Quizzes",
    "Accessibility Modifications": "Accessibility Modifications",
    "Alternative Assignment": "Alternative Assignment",
    "Captions": "Captions",
    "Direct Assessment": "Direct Assessment",
    "Discussion Question and Participation Modification Accommodation": "Discussion Question and Participation Modification Accommodation",
    "Modified Course Services": "Modified Course Services",
    "PDF": "PDF",
    "Pre-Course Check In": "Pre-Course Check In",
    "Provision of digital recording device": "Provision of digital recording device",
    "Remote Attendance": "Remote Attendance",
    "Scribe/Aide": "Scribe/Aide",
    "Service Animal": "Service Animal",
    "Transcripts": "Transcripts"
  };

  const findAccommodationMatch = (accommodation) => {
    // map old values to new ones
    const mappedAccommodation = oldToNewAccommodationMapping[accommodation] || accommodation;

    const match = accommodations.find(
      (item) => item.text?.toLowerCase() === mappedAccommodation.toLowerCase()
    );

    return match ? match.id : null;
  };

  const getDisplayText = (accommodation) => {
    return oldToNewAccommodationMapping[accommodation] || accommodation;
  };

  const sortAndOrderAccommodations = (inputAccommodations) => {
    const regularAccommodations = [];
    const specialArrangementsType = [];
    const actualSpecialArrangements = [];

    inputAccommodations.forEach(accommodation => {
      const displayText = getDisplayText(accommodation);
      
      if (displayText.toLowerCase() === "special arrangements") {
        // "Special Arrangements" accommodation
        specialArrangementsType.push(accommodation);
      } else {
        const accommodationMatch = accommodations.find(
          (item) => item.text?.toLowerCase() === displayText.toLowerCase()
        );
        
        if (!accommodationMatch) {
          // Special Arrangements
          actualSpecialArrangements.push(accommodation);
        } else {
          regularAccommodations.push(accommodation);
        }
      }
    });

    // Sort regular accommodations alphabetically
    const sortedRegularAccommodations = regularAccommodations.sort((a, b) => {
      const displayTextA = getDisplayText(a).toLowerCase();
      const displayTextB = getDisplayText(b).toLowerCase();
      return displayTextA.localeCompare(displayTextB);
    });

    // return in the following order: sorted accommodation list, "Special Arrangements" if that accommodation exists, followed by special arrangements
    return [...sortedRegularAccommodations, ...specialArrangementsType, ...actualSpecialArrangements];
  };

  return (
    <>
      <TableRow
        key={props.student.studentIrn}
        className={
          mainRowInfoObject.displayAccommodationTypes.length === 0
          ? classes.errorContainer
          : hasNewAccommodation 
            ? classes.newAccomContainer
            : classes.rowContainer
        }
      >
        <TableCell
          align="left"
          className={
            mainRowInfoObject.displayAccommodationTypes.length === 0
            ? classes.errorContainer
            : hasNewAccommodation
              ? classes.newAccomStickyColumn
              : classes.stickyColumn
          }
        >
          <Typography
            id={`studentFullName${props.key}-${props.courseOfferingId}`}
            className={classes.boldText}
          >
            {props.student.fullName !== "null null"
              ? props.student.fullName
              : ""}
          </Typography>{" "}
          {props.student.studentIrn}
        </TableCell>
        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>
          <Link
            component="button"
            underline="none"
            onClick={() => {
              props.setContactInfoDisabilityType(disabilityType);
              props.setModalType("contact");
              props.setOpenModal(true);
            }}
            className={classes.linkText}
            style={{
              margin: "0px 4px 2px 0",
              lineHeight: 1.5,
              background: 'none',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            <Typography display="inline">
              {disabilityType}
            </Typography>
          </Link>
        </TableCell>
        <TableCell align="left">
          {newAccommodationTypes.length > 0 &&
            accommodationTypesAcknowledged.length > 0 && (
              <div className={classes.newAccommodationIcon}>
                <Typography className={classes.newAccommodationIconText}>
                  NEW
                </Typography>
              </div>
            )}
          {newAccommodationTypes.length > 0 &&
            newAccommodationTypes.map((accommodation, index) => {
              let linkId;
              let hrefValue;
              if (accommodation) {
                linkId = findAccommodationMatch(accommodation);
                hrefValue = linkId
                  ? `${process.env.REACT_APP_ACCOMMODATION_DICTIONARY_URL}#${linkId}`
                  : "#"; // Default to "#" if no match is found
              }
              return (
                <React.Fragment key={index}>
                  <div>
                    {hrefValue === "#" ? (
                      <Typography display="inline">
                        {accommodation && accommodation !== "null" && (
                          <>
                            {`${getDisplayText(accommodation)}`}
                            {index < newAccommodationTypes.length - 1 && (
                              <span style={{ marginLeft: "2px" }}>{`;`}</span>
                            )}
                          </>
                        )}
                      </Typography>
                    ) : (
                      <Link
                        component="a"
                        underline="none"
                        href={hrefValue}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.linkText}
                        style={{
                          margin: "0px 4px 2px 0",
                          lineHeight: 1.5,
                        }}
                      >
                        <Typography display="inline">
                          {`${getDisplayText(accommodation)}`}
                          {index < newAccommodationTypes.length - 1 && (
                            <span style={{ marginLeft: "2px" }}>{`;`}</span>
                          )}
                        </Typography>
                      </Link>
                    )}
                  </div>
                </React.Fragment>
              );
            })}
          {newAccommodationTypes.length > 0 &&
            accommodationTypesAcknowledged.length > 0 && (
              <>
                <br />
                <br />
              </>
            )}
          {accommodationTypesAcknowledged.map((accommodation, index) => {
            let linkId;
            let hrefValue;
            if (accommodation) {
              linkId = findAccommodationMatch(accommodation);
              hrefValue = linkId
                ? `${process.env.REACT_APP_ACCOMMODATION_DICTIONARY_URL}#${linkId}`
                : "#";
            }

            return (
              <React.Fragment key={index}>
                <div
                  style={{
                    marginRight: "4px",
                    marginBottom: "2px",
                  }}
                >
                  {hrefValue === "#" ? (
                    <Typography display="inline">
                      {accommodation && accommodation !== "null" && (
                        <>
                          {`${getDisplayText(accommodation)}`}
                          {index < accommodationTypesAcknowledged.length - 1 && (
                            <span style={{ marginLeft: "2px" }}>{`;`}</span>
                          )}
                        </>
                      )}
                    </Typography>
                  ) : (
                    <Link
                      component="a"
                      underline="none"
                      href={hrefValue}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classes.linkText}
                      style={{
                        lineHeight: 1.5,
                      }}
                    >
                      <Typography display="inline">
                        {`${getDisplayText(accommodation)}`}
                        {index < accommodationTypesAcknowledged.length - 1 && (
                          <span style={{ marginLeft: "2px" }}>{`;`}</span>
                        )}
                      </Typography>
                    </Link>
                  )}
                </div>
              </React.Fragment>
            );
          })}
        </TableCell>
        <TableCell>
          <TextField
            id="description-notes"
            name="course"
            onChange={handleNotesChange}
            value={noteValue}
            placeholder={focused && noteValue.length === 0 ? "" : ""}
            variant="outlined"
            color="secondary"
            multiline
            minRows={1}
            disabled={
              hasNewAccommodation ||
              mainRowInfoObject.displayAccommodationTypes.length === 0
            }
            aria-label={
              noteValue.length > 0 ? "Course notes" : "Type something"
            }
            inputProps={{
              maxLength: 2000,
            }}
            InputProps={{
              style: {
                paddingRight: "48px",
              },
              endAdornment: (
                <InputAdornment
                  position="end"
                  style={{
                    position: "absolute",
                    top: "24px",
                    right: "8px",
                    alignSelf: "flex-start",
                    padding: "2px",
                    borderRadius: "50%",
                    zIndex: 1,
                  }}
                >
                  {noteHasChanged &&
                  !(
                    hasNewAccommodation ||
                    mainRowInfoObject.displayAccommodationTypes.length === 0
                  ) ? (
                    // display Tooltip when save button is enabled AND noteHasChanged
                    <Tooltip title="Save Notes" placement="top" arrow>
                      <span>
                        <IconButton
                          position="end"
                          className={classes.iconButton}
                          onClick={handleSaveNotes}
                          tabIndex={0}
                          role="button"
                          aria-label="Save notes"
                          disabled={false}
                        >
                          <SaveIcon
                            aria-hidden="true"
                            className={classes.saveIcon}
                          />
                        </IconButton>
                      </span>
                    </Tooltip>
                  ) : (
                    // No tooltip in all other cases
                    <IconButton
                      position="end"
                      className={classes.iconButton}
                      onClick={handleSaveNotes}
                      tabIndex={0}
                      role="button"
                      aria-label="Save notes"
                      disabled={
                        !noteHasChanged ||
                        hasNewAccommodation ||
                        mainRowInfoObject.displayAccommodationTypes.length === 0
                      }
                    >
                      <SaveIcon
                        aria-hidden="true"
                        className={
                          noteHasChanged &&
                          !(
                            hasNewAccommodation ||
                            mainRowInfoObject.displayAccommodationTypes
                              .length === 0
                          )
                            ? classes.saveIcon
                            : classes.saveIconDisabled
                        }
                      />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
            className={
              hasNewAccommodation ||
              mainRowInfoObject.displayAccommodationTypes.length === 0
                ? classes.textFieldGray
                : classes.textField
            }
            label={
              noteValue.length > 0 && !focused
                ? ""
                : focused
                ? noteValue.length === 0
                  ? "Optional field"
                  : "Optional field"
                : "Type something..."
            }
            InputLabelProps={{
              shrink: noteValue.length > 0 || focused,
              "aria-hidden": "true",
            }}
            onFocus={handleFocus}
          />
        </TableCell>

        <TableCell className={classes.tableCell}>
          <Select
            value={gradeValue ? "Yes" : "No"}
            onChange={handleGradeChange}
            displayEmpty
            variant="outlined"
            color="secondary"
            className={
              hasNewAccommodation ||
              mainRowInfoObject.displayAccommodationTypes.length === 0
                ? classes.selectGray
                : classes.select
            }
            disabled={
              hasNewAccommodation ||
              mainRowInfoObject.displayAccommodationTypes.length === 0
            }
          >
            <MenuItem
              value="Yes"
              aria-label="Yes"
              className={classes.menuItemFocused}
            >
              Yes
            </MenuItem>
            <MenuItem
              value="No"
              aria-label="No, negative"
              className={classes.menuItemFocused}
            >
              No
            </MenuItem>
          </Select>
        </TableCell>
        <TableCell align="center">
        {mainRowInfoObject.displayAccommodationTypes.length === 0 ? (
          <>
            <div>
              <ErrorIcon
                className={classes.errorIcon}
                aria-label="error icon"
                aria-hidden="false"
              />
            </div>
            <Button
              href="#"
              className={classes.linkText}
              role="button"
              onClick={handleOpenModal}
              disableRipple
            >
              <div>
                <Typography>Contact Student Accommodations Office</Typography>
              </div>
            </Button>
          </>
        ) : hasNewAccommodation ? (
            <>
              <div>
                <WarningIcon
                  className={classes.warningIcon}
                  aria-label="warning icon"
                  aria-hidden="false"
                />
              </div>
              <Button
                href="#"
                className={classes.linkText}
                role="button"
                onClick={handleOpenModal}
                disableRipple
              >
                <div>
                  <Typography>
                    {hasAcknowledgedAccommodation
                      ? "Updated student"
                      : "New student"}
                  </Typography>
                  <Typography>accommodation</Typography>
                </div>
              </Button>
            </>
          ) : (
            <>
              <Button
                href="#"
                role="button"
                className={classes.linkText}
                aria-label="Review Notification link"
                onClick={handleOpenModal}
                disableRipple
              >
                <Typography>Review Notification</Typography>
              </Button>
            </>
          )}
        </TableCell>
      </TableRow>
      {openSuccess && renderSnackbar()}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    personsWithName: state.personsWithName,
    facultyDemographics: state.demographics,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPersonInfoWithName: (irn, personType) =>
      dispatch(getPersonInfoWithName(irn, personType)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CourseTableRow);
